import React, { Component } from "react";
import { Card, Grid, Button } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { withRouter } from "react-router-dom";
import { withToastManager } from "react-toast-notifications";
import { resetPassword } from "../../services/user";

class ResetPassword extends Component {
  state = {
    newPassword: "",
    confirmPassword: "",
  };

  componentDidMount() {
    // custom rule will have name 'isPasswordMatch'
    ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
      const { newPassword } = this.state;
      if (value !== newPassword) {
        return false;
      }
      return true;
    });
  }

  handlePassword = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleResetPassword = () => {
    const { newPassword } = this.state;
    const userToken = window.location.pathname.split("/").pop();
    const { toastManager } = this.props;
    const body = {
      password: newPassword,
      userToken,
    };

    resetPassword(body)
      .then((res) => {
        if (res.data.success) {
          toastManager.add(res.data.message, {
            appearance: "success",
            autoDismiss: true,
          });
          this.setState({
            newPassword: "",
            confirmPassword: "",
          });
        }
      })
      .catch((err) => {
        let message;
        if (err.response) {
          message = err.response.data.message;
        } else {
          message = err.message;
        }
        toastManager.add(message, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  render() {
    let { newPassword, confirmPassword } = this.state;

    return (
      <div className="signup flex justify-center w-full h-full-screen">
        <div className="p-8">
          <Card className="forget-card position-relative y-center">
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-8 flex justify-center items-center h-full">
                  <img src="/assets/images/eazydiner_1.jpg" alt="" />
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <div className="p-9 h-full bg-light-gray position-relative">
                  <ValidatorForm ref="form" onSubmit={this.handleResetPassword}>
                    <TextValidator
                      className="mb-6 w-full"
                      variant="outlined"
                      label="New password"
                      onChange={this.handlePassword}
                      type="password"
                      name="newPassword"
                      value={newPassword}
                      validators={["required"]}
                      errorMessages={["*Field required"]}
                    />
                    <TextValidator
                      className="mb-6 w-full"
                      variant="outlined"
                      label="Confirm password"
                      onChange={this.handlePassword}
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword}
                      validators={["isPasswordMatch", "required"]}
                      errorMessages={[
                        "*Password does not match",
                        "*Field required",
                      ]}
                    />
                    <div className="flex items-center">
                      <Button variant="contained" color="primary" type="submit">
                        Change Password
                      </Button>
                    </div>
                  </ValidatorForm>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

export default withRouter(withToastManager(ResetPassword));
